import React, { Component } from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";

import Row from "../common/layout/row";
import "./resultados.css";

import { Sistema_ID } from "../modules/constants";

//Actions
import { selectConcursoScreen } from "../reducers/concurso/concursoActions";
import {
  recuperaResultado,
  cleanResultado,
} from "../reducers/relatorios/resultadosActions";

import DayPickerInput from "react-day-picker/DayPickerInput";
import "react-day-picker/lib/style.css";

import MomentLocaleUtils from "react-day-picker/moment";
import { formatDate, parseDate } from "react-day-picker/moment";
import "moment/locale/pt-br";
import { forceInt } from "../utils/forceInt";

class Resultados extends Component {
  constructor(props) {
    super(props);
    this.state = {
      currentDate: new Date(),
      isEmpty: true,
      isDisabled: false,
      isLoading: false,
    };

    this.goHome = this.goHome.bind(this);
    this.loadResultado = this.loadResultado.bind(this);
    this.getListOk = this.getListOk.bind(this);
    this.renderResultado = this.renderResultado.bind(this);
    this.renderResultadoRows = this.renderResultadoRows.bind(this);
    this.renderDateRange = this.renderDateRange.bind(this);
    this.handleCurrentDayChange = this.handleCurrentDayChange.bind(this);
  }

  componentWillMount() {
    this.props.cleanResultado([]);
    //this.loadResultado();
  }

  componentDidUpdate() {}

  getListOk() {
    this.setState({
      isLoading: false,
    });
  }

  loadResultado() {
    this.setState({
      isLoading: true,
    });

    var transaction = {};
    transaction.Sistema_ID = Sistema_ID;
    transaction.Cliente_ID = this.props.objUser.Cliente_ID;
    transaction.Site_ID = forceInt(this.props.objUser.Site_ID);
    transaction.CID = this.props.objUser.CID;
    transaction.chrSerial = this.props.objUser.ChrSerial;
    transaction.Session_ID = this.props.objUser.Session_ID;
    transaction.LoginLE = this.props.objUser.LoginLE;
    transaction.sdtData = this.state.currentDate;

    this.props.recuperaResultado(transaction, this.getListOk);
  }

  goHome() {
    this.props.selectConcursoScreen(0);
  }

  handleCurrentDayChange(selectedDay, modifiers, dayPickerInput) {
    const input = dayPickerInput.getInput();

    this.setState({
      currentDate: selectedDay,
    });
  }

  renderDateRange() {
    try {
      return (
        <div>
          <DayPickerInput
            value={this.state.currentDate}
            onDayChange={this.handleCurrentDayChange}
            format="L"
            formatDate={formatDate}
            parseDate={parseDate}
            dayPickerProps={{
              selectedDays: this.state.currentDate,
              localeUtils: MomentLocaleUtils,
              locale: "pt-br",
            }}
          />
          <button type="button" className="btn" onClick={this.loadResultado}>
            Ok
          </button>
        </div>
      );
    } catch (error) {
      alert(error);
    }
  }

  renderResultadoRows(arrResultado) {
    if (arrResultado != undefined) {
      return arrResultado.map((res) => (
        <tr role="row" className="odd">
          <td>{res.premio}</td>
          <td>{` ${res.numero} `}</td>
          <td>{` ${res.numeroBicho} - ${res.nomeBicho}`}</td>
        </tr>
      ));
    } else return null;
  }

  renderResultado() {
    if (
      this.props.resultadoJBWeb != undefined &&
      this.props.resultadoJBWeb.arrExtracaoResultado != undefined
    ) {
      return this.props.resultadoJBWeb.arrExtracaoResultado.map((res) => (
        <div className="row">
          <div className="col-sm-12">
            <h4>{res.descricao}</h4>
            <table
              id="example2"
              className="table table-bordered table-hover dataTable"
              role="grid"
              aria-describedby="example2_info"
            >
              <thead>
                <tr role="row">
                  <th tabindex="0">Prêmio</th>
                  <th tabindex="0">Resultado</th>
                  <th tabindex="0">Grupos</th>
                </tr>
              </thead>
              <tbody>{this.renderResultadoRows(res.arrResultado)}</tbody>
            </table>
          </div>
        </div>
      ));
    }
  }

  render() {
    const detailsColumnStyle = {
      width: "10px",
    };

    let loader = !this.state.isLoading ? null : (
      <div className="loader" style={{ marginTop: "0" }}></div>
    );

    return (
      <div className={"suas-apostas-container " + this.state.startDate}>
        <section className="col-xs-12">
          <div className="box">
            <div className="box-header header">
              <div className="col-xs-12">
                <a className="btn btn-danger pull-right" onClick={this.goHome}>
                  Voltar
                </a>
              </div>
              <div className="col-xs-12">
                <span className="box-title">Resultado</span>
                {this.renderDateRange()}
              </div>
            </div>
            <div className="box-body">
              {this.renderResultado()}
              {loader}
            </div>
            <div className="box-footer">
              <Row></Row>
            </div>
          </div>
        </section>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  objUser: state.usuario.objUser,
  resultadoJBWeb: state.resultados.resultadoJBWeb,
  concursoType: state.concurso.concursoType,
});
const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      selectConcursoScreen,
      recuperaResultado,
      cleanResultado,
    },
    dispatch
  );
export default connect(mapStateToProps, mapDispatchToProps)(Resultados);



// WEBPACK FOOTER //
// ./src/relatorios/resultados.jsx